// extracted by mini-css-extract-plugin
export default {"modalContainer":"Options_modalContainer__oymeF","form":"Options_form__GRJCF","input":"Options_input__h31Rz","addOptionSubmit":"Options_addOptionSubmit__kDbUc"};